import { P2GBox } from '@parcel2go/core-ui';
import Loading from '../../../../components/loading/Loading';

export interface processingProps {
  processing: boolean;
  className?: string | undefined;
  children: React.ReactNode;
}

const SmartSendProcessing: React.FC<processingProps> = (props) => {
  return (
    <P2GBox sx={{ position: 'relative' }} className={props.className}>
      <P2GBox
        aria-hidden={!props.processing}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          position: 'absolute',
          width: '100%',
          top: 0,
          zIndex: 1,
          opacity: props.processing ? 1 : 0,
          pointerEvents: props.processing ? 'auto' : 'none',
          backgroundColor: props.processing ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255,0)',
          transition: 'opacity 0.3s ease, background-color 0.3s ease'
        }}
      >
        <Loading />
      </P2GBox>
      <P2GBox>{props.children}</P2GBox>
    </P2GBox>
  );
};

export { SmartSendProcessing };
